import { useDispatch } from 'react-redux'
import { useCallback } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { useNavigate } from 'react-router-dom'
import { useI18n } from 'builder/hooks/useI18n'
import {
  actions,
  AutoTailoringFromPublicJobBoardStep,
  AutoTailoringMode,
  createAutoTailoringUrlParams,
  selectors,
} from 'builder/modules/resumeEditor'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { ButtonTheme, ButtonV2 } from 'builder/components/Button'
import { useTailoredResumeEdit } from 'builder/components/AutoTailoring/OverviewModal/hooks/useTailoredResumeEdit'
import { FetchStatuses } from 'builder/modules/constants'

export const TailoringFromPublicJobBoardStep2Buttons = () => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { processingAutoTailoring, mode, jobCardId, jobPostingId } = useTypedSelector(
    selectors.autoTailoringFromPublicJobBoard,
  )
  const { handleRedirect, currentResume } = useTailoredResumeEdit()

  const handleSkipTailorManually = useCallback(() => {
    if (!currentResume) return

    switch (mode) {
      case AutoTailoringMode.fromMemberJB:
        trackInternalEvent('click_cancel_tailoring')

        const searchParams = createAutoTailoringUrlParams({
          mode,
          jobCardId,
          jobPostingId,
          autotailoringStep: AutoTailoringFromPublicJobBoardStep.step2,
          resumeId: currentResume.id,
          showSelfTailorModal: true,
        })

        navigate(`/resumes/${currentResume.id}/edit?${searchParams.toString()}`)
        break
      case AutoTailoringMode.fromPublicJB:
      default:
        trackInternalEvent('click_tailor_manually', { label: 'tailored_result' })
        dispatch(
          actions.skipAutoTailorForJobBoard({
            mode,
            tailoredResumeId: currentResume.id,
            jobCardId,
            shouldRemoveAutoTailoredResume: false,
          }),
        )
        break
    }
  }, [dispatch, mode, currentResume, jobCardId, jobPostingId, navigate])

  const handleUseTailoredResume = useCallback(() => {
    if (!currentResume) return

    trackInternalEvent('click_use_tailored_resume')

    dispatch(
      actions.approveResumeForJobBoardFlow({
        resumeId: currentResume?.id,
        handleSuccessRedirect: handleRedirect,
        jobCardId,
      }),
    )
  }, [currentResume, dispatch, handleRedirect, jobCardId])

  return (
    <>
      <ButtonV2
        theme={ButtonTheme.ghost}
        isDisabled={processingAutoTailoring === FetchStatuses.loading}
        onClick={handleSkipTailorManually}
        data-testid="skip-tailor-manually-button"
      >
        {mode === AutoTailoringMode.fromMemberJB
          ? i18n.t(`builder.prefill_resume.auto_tailoring_view.header.cancel`)
          : i18n.t(`builder.prefill_resume.auto_tailoring_view.header.skip_tailor_manually`)}
      </ButtonV2>

      <ButtonV2
        isDisabled={processingAutoTailoring === FetchStatuses.loading}
        onClick={handleUseTailoredResume}
        data-testid="use-tailored-resume-button"
      >
        {i18n.t(`builder.prefill_resume.auto_tailoring_view.header.use_tailored_resume`)}
      </ButtonV2>
    </>
  )
}
